export default "__VITE_ASSET__c744fa9b__"